











































































































































import { Component, Prop, Watch, Vue } from 'vue-property-decorator'
/* module */
import Local from '@/app/module/local'
import Session from '@/app/module/session'
import DateClass from '@/app/module/date'
import { routerPath, errorFlag } from '@/app/model/store/domain/const'
import CommonClass from '@/app/module/common'

@Component
export default class FieldInfoModal extends Vue {
  @Prop() private fieldInfo!: any

  created () {
  }

  private displayValue (val: any, unit: string) {
    if (!val) {
      return '－'
    }
    return val + (unit || '')
  }

  // 2006-01-02 -> 2006年1月2日
  private displayDate (dateStr: string) {
    if (!dateStr) {
      return '－'
    }
    const year = dateStr.substring(0, 4)
    const month = dateStr.substring(5, 7).replace(/^0/, '')
    const date = dateStr.substring(8, 10).replace(/^0/, '')
    return `${year}年${month}月${date}日`
  }

  private getPastPlantingsSeason () {
    if (!this.fieldInfo.past_plantings || this.fieldInfo.past_plantings.length === 0) {
      return null
    }
    const seasons = this.fieldInfo.past_plantings.map((e: any) => e.planting_year)
    return seasons.map((e: any) => `${e}年`).join('・')
  }

  private getSensorList () {
    if (!this.fieldInfo.sensor_key_map || Object.keys(this.fieldInfo.sensor_key_map).length === 0) {
      return null
    }
    const sensors: string[] = []
    if (this.fieldInfo.sensor_key_map.pw_sensor_key) {
      sensors.push('PW-2300')
    }
    if (this.fieldInfo.sensor_key_map.fs_sensor_key) {
      sensors.push('FS-2300')
    }
    if (this.fieldInfo.sensor_key_map.fc_sensor_key) {
      sensors.push('FC-1000')
    }
    return sensors.join('、')
  }

  private closeModal () {
    this.$emit('close-field-info-modal')
  }
}
